import { Row } from 'antd'
import HomePageButton from 'app/components/UI-Elements/General/HomePageButton'
import Icon from 'app/components/UI-Elements/General/Icon'
import Container from 'app/components/UI-Elements/Layout/Container'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { TransactionalSuccessType } from 'app/constants/Enums'
import useTranslation from 'app/lib/hooks/useTranslation'
import { getQueryString } from 'app/lib/utils/search-params'
import { PageProps } from 'app/pages/typing'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

const Confirmation: React.FC<PageProps> = ({ route }) => {
  const { tRoute } = useTranslation({ scope: route.key })
  const { search } = useLocation()
  const [type, setType] = useState<TransactionalSuccessType>(null)

  useEffect(() => {
    setType(getQueryString(search, 'type') as TransactionalSuccessType)
  }, [])

  const idType = type ?? 'default'

  return (
    <Container card={false}>
      <Row justify="center">
        <KCol xs={24} md={18} lg={14} card>
          <Row gutter={[0, 24]} className="text-center my-5">
            <KCol span={24}>
              <h3>{tRoute({ id: `${idType}_title` })}</h3>
            </KCol>
            <KCol span={24}>
              <Icon iconStyles={{ width: 100, height: 100 }} type="check" />
            </KCol>
            <KCol span={24} className="text-center">
              <p>{tRoute({ id: `${idType}_content` })}</p>
            </KCol>
            <KCol span={24}>
              <HomePageButton />
            </KCol>
          </Row>
        </KCol>
      </Row>
    </Container>
  )
}

export default Confirmation
